import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { HomeComponent } from '../home/home.component';
import { PickupComponent } from '../pickup/pickup.component';

@Component({
  selector: 'app-delivery-dialog',
  templateUrl: './delivery-dialog.component.html',
  styleUrls: ['./delivery-dialog.component.scss']
})
export class DeliveryDialogComponent {  

  constructor(
    public dialogRef: MatDialogRef<DeliveryDialogComponent>,
    public homeDeliveryChoiceDialogRef: MatDialog,
    @Inject(MAT_DIALOG_DATA) 
    public injectedDeliveryChoiceResponse){}

    onNoClick(): void {
      this.dialogRef.close();
    }
    //Appel de la popin Home (formulaire choix de date/email)
    openHomeDeliveryChoice(){
      this.homeDeliveryChoiceDialogRef.open(HomeComponent,{ disableClose: true ,panelClass: 'homeChoice-dialog', data:{ "deliveryChoiceResponse" : this.injectedDeliveryChoiceResponse.deliveryChoiceResponse, "tag":this.injectedDeliveryChoiceResponse.tag, "shortCode1":this.injectedDeliveryChoiceResponse.shortCode1, "shortCode2": this.injectedDeliveryChoiceResponse.shortCode2, "isModify": this.injectedDeliveryChoiceResponse.isModify}} );
      this.dialogRef.close();
    }

    //Appel de la popin PickUp (formulaire choix du point de retrait/BP)
    openPickupDeliveryChoice(){
      this.homeDeliveryChoiceDialogRef.open(PickupComponent,{ disableClose: true , panelClass: 'pickupChoice-dialog', data:{ "deliveryChoiceResponse" : this.injectedDeliveryChoiceResponse.deliveryChoiceResponse, "tag":this.injectedDeliveryChoiceResponse.tag, "shortCode1": this.injectedDeliveryChoiceResponse.shortCode1, "shortCode2": this.injectedDeliveryChoiceResponse.shortCode2, "isModify": this.injectedDeliveryChoiceResponse.isModify}} );
      this.dialogRef.close();
    } 
}

